import { defineMessages } from 'react-intl';

export default defineMessages({
	audioVideoSettings: {
		id: 'fmSettings.audioVideoSettings',
		defaultMessage: 'Audio/Video Settings',
		description: 'Audio/Video Settings title',
	},

	microphone: {
		id: 'fmSettings.microphone',
		defaultMessage: 'Microphone',
		description: 'microphone label',
	},

	speakers: {
		id: 'fmSettings.speakers',
		defaultMessage: 'Speakers',
		description: 'Speakers label',
	},

	camera: {
		id: 'fmSettings.speakers',
		defaultMessage: 'Test',
		description: 'Test label',
	},

	test: {
		id: 'PilotApp.test',
		defaultMessage: 'Test',
		description: 'Test label',
	},
});
